import {
  DefaultErrorFunction,
  SetErrorFunction,
} from "@sinclair/typebox/errors"

declare module "@sinclair/typebox" {
  export interface SchemaOptions {
    /**
     * @description Custom error message
     */
    errorMessage?: string
  }
}

SetErrorFunction(error => {
  return error?.schema?.errorMessage ?? DefaultErrorFunction(error)
})
